function setEqualHeights() {
  const div1 = document.querySelector('.product .prod-image-main');
  const div2 = document.querySelector('.product .thumbnail-slider');
  if (!div1 || !div2) return;
  if (div2) {
    div2.style.width = div1.offsetHeight + 'px';
  }
  var mediaQuery = window.matchMedia("(min-width: 990px)");
  mediaQuery.addListener(handleMediaQueryChange);
  function handleMediaQueryChange(event) {
  if (event.matches) {
    // Media query matches, do something
    div2.style.width = div1.offsetHeight + 'px';
  }
}
}

// Run when DOM is ready
document.addEventListener('DOMContentLoaded', setEqualHeights);

// Re-run on resize (for responsive updates)
window.addEventListener('resize', () => {
  // clearTimeout(window._resizeTimer);
  // window._resizeTimer = setTimeout(setEqualHeights, 100);
  setEqualHeights();
});


